import React from 'react';
import { Box, Input, Typography, makeStyles } from '@material-ui/core';
import { theme, userDarkMode } from 'theme';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({
  textFieldContainer: {
    margin: '12px 0',
  },
  label: {
    fontSize: 14,
    lineHeight: '2.4rem',
    color: theme.palette.grey[800],
  },
  input: {
    height: 40,
    width: '100%',
    flex: 1,
    padding: 10,
    backgroundColor: theme.palette.grey[600],
    border: `0.5px solid ${userDarkMode ? '#313036' : '#e4e6ce'}`,
    borderRadius: 4,
    color: theme.palette.grey[800],
  },
  required: {
    color: 'red',
  },
});

interface TextFieldLabelProps {
  name: string;
  label: string;
  required?: boolean;
  value: string | number;
  type?: string;
  placeholder?: string;
  error?: boolean;
  onChange: (event: React.ChangeEvent) => void;
}

function TextFieldLabelStep({
  label,
  value,
  name,
  onChange,
  placeholder,
  required = false,
  type = 'text',
  error = false,
}: TextFieldLabelProps) {
  const { t, i18n } = useTranslation();
  const classes = useStyles();

  return (
    <Box className={classes.textFieldContainer}>
      <Typography className={classes.label}>
        {label}
        {required && <span className={classes.required}>*</span>}
      </Typography>
      <Input
        name={name}
        className={classes.input}
        type={type}
        value={value}
        onChange={onChange}
        disableUnderline={!error}
        error={error}
        placeholder={placeholder}
      />
    </Box>
  );
}

export default TextFieldLabelStep;
